export default __webpack_public_path__ + "static/media/kitchen3-afterA-768w.15da45a2.avif";